const doc = [({"en":({"js":({"merfoto":({"tenant_photo_products_with_photos":({"card":({"index":({"download":"Download"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;